module.exports = __webpack_public_path__ + "assets/img/android-portrait.c11bdbf.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/android-portrait.png
// module id = v6+Z
// module chunks = 50